const FORMATADOR_BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

/** 1250 → "R$ 12,50" (com espaço inseparável, como o Intl devolve). */
export function formatarReais(centavos: number): string {
  return FORMATADOR_BRL.format(centavos / 100);
}

/**
 * Lê o que a pessoa digita no balcão: "12,50", "12.50", "R$ 1.234,56", "12".
 * Devolve centavos ou null quando não é um valor válido.
 */
export function lerReais(texto: string): number | null {
  const limpo = texto.replace(/[R$\s ]/g, '');
  if (limpo === '' || !/^[\d.,]+$/.test(limpo)) return null;

  const ultimaVirgula = limpo.lastIndexOf(',');
  const ultimoPonto = limpo.lastIndexOf('.');
  const separador = Math.max(ultimaVirgula, ultimoPonto);
  // Separador decimal só conta com 1 ou 2 casas depois; senão é milhar ("1.234").
  const temDecimal = separador >= 0 && limpo.length - separador - 1 <= 2;

  const inteiro = (temDecimal ? limpo.slice(0, separador) : limpo).replace(/[.,]/g, '');
  const decimal = temDecimal ? limpo.slice(separador + 1).padEnd(2, '0') : '00';
  if (inteiro === '' && decimal === '00') return null;

  const centavos = Number(inteiro || '0') * 100 + Number(decimal);
  return Number.isSafeInteger(centavos) ? centavos : null;
}

export function totalDoPedido(p: { valorCentavos: number; taxaEntregaCentavos: number }): number {
  return p.valorCentavos + p.taxaEntregaCentavos;
}

/** Quanto o entregador leva de troco. null quando não há troco a levar. */
export function trocoALevar(
  totalCentavos: number,
  trocoParaCentavos: number | null,
): number | null {
  if (trocoParaCentavos == null || trocoParaCentavos <= totalCentavos) return null;
  return trocoParaCentavos - totalCentavos;
}
